var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.72,
    height: 43.087,
    viewBox: "0 0 132.72 43.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.194,
    x2: 0.5,
    y2: -0.126,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e42f18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e2122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e21518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f9ba1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(38.175 151.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M4.689,28.936c-.142-3.14,1.16-5.555,2.788-8.068,1.965-3.025,3.637-5.6.169-10.063.725,3.164-.888,5.218-2.7,7.559-3.552,4.57-5.623,9.524-3.193,15.212C3.7,38.135,7.968,41.011,12.7,42.1c-.169-5.463,2.22-8.044,4.348-10.335,2.415-2.6,4.664-5.327,1.548-10.891,3.066,4.028,3.069,6.9-1.057,11.347-3.256,3.5-4.4,5.777-4.126,10.714-5.327-1.1-10.063-3.91-12.271-9.092C-1.381,27.921.717,22.724,4.431,17.953,7.805,13.614,7.794,12.46,5.692,7.624c4.786,5.162,6.449,7.3,2.347,13.614-1.551,2.388-2.815,4.682-2.664,7.677.124,2.791,1.684,5.946,6.807,8.393-3.942-1-7.278-4.084-7.473-8.367Zm5.363-.334a5.473,5.473,0,0,0,3.516,4.857,6.251,6.251,0,0,1-2.847-4.9C10.4,23.449,16.231,17.58,16.7,9.918,17,5.1,15.714,2.246,11.591,0A14.214,14.214,0,0,1,9.845,11.782c.124.21.246.423.355.639,2.14-2.735,3.1-7.671,2.477-11.033,3.063,2,3.552,5.159,3.356,8.5C15.56,17.583,9.714,23.132,10.052,28.6ZM20.538,13.727c-1.48-2.122-2.5-3.593-2.235-4.963-.814,1.7.37,3.427,1.693,5.321a15.485,15.485,0,0,1,2,3.5,5.164,5.164,0,0,1,.521-.509,17.5,17.5,0,0,0-1.971-3.344Zm-.559,3.013c-1.184-1.921-1.776-2.72-1.687-3.93-.568,1.527.222,2.8,1.125,4.259a11.134,11.134,0,0,1,1.625,3.785,6.141,6.141,0,0,1,.142-1.912,16.573,16.573,0,0,0-1.2-2.193Zm1.435,13c-1.853,4.818-6.884,6.621-6.017,13.333,7.84.275,14.206-5.031,14.881-12.862A26.4,26.4,0,0,0,27.73,17.45a34.169,34.169,0,0,0-8.76-11.8c-1.021,3.125,1.912,5.239,3.575,7.932A25.881,25.881,0,0,1,26.4,24.438a15.778,15.778,0,0,1,.719,2.678c.272-4.59-1.394-9.6-3.948-13.774-1.042-1.7-3.93-4.777-3.8-6.479a33.722,33.722,0,0,1,7.757,10.829,25.732,25.732,0,0,1,2.486,12.43A13.318,13.318,0,0,1,15.995,42.429c-.642-5.6,4.158-7.991,5.425-12.679Zm4.658,1.406c1.734-2.85-.63-7.642-1.139-8.879-.888-2.146-1.364-3.208-1.184-5.478C20.973,18.539,21.414,20.188,22,23.3c.545,2.9,1.2,6.437-1.29,10.024,3.637-2.243,2.187-8.843,1.95-10.1-.4-2.152-.728-3.936.37-5.07a14.389,14.389,0,0,0,1.3,4.339C25.3,24.861,26.433,27.631,26.072,31.15Z",
    transform: "translate(64.2 -151.295)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-125 -85.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M7.83,170.46a8.36,8.36,0,0,1,.27-2.41,7,7,0,0,1,.72-1.56H12a15.32,15.32,0,0,0-.34,3.61v6.72H7.83Zm11-5.49a3.7,3.7,0,0,0-.91-2.75,4,4,0,0,0-2.83-.87H7.86v-3.11h7.49a7.8,7.8,0,0,1,5.5,1.77,6.62,6.62,0,0,1,1.92,5.12v11.69H18.82Z",
    transform: "translate(79 -211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M27.62,177c-.51-.06-1.07-.16-1.7-.29v-3a13.721,13.721,0,0,0,2.28.17,2.23,2.23,0,0,0,1.75-.65,3,3,0,0,0,.58-2v-9.86H27.14v-3.11h7.39v13.28a5.78,5.78,0,0,1-1.39,4.15,5.15,5.15,0,0,1-3.92,1.46A11.643,11.643,0,0,1,27.62,177Z",
    transform: "translate(79 -211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M39.92,158.24H47.5q7.34,0,7.38,7.06v11.52h-4V165a4,4,0,0,0-.82-2.78,3.33,3.33,0,0,0-2.57-.89H43.88V176.8h-4Z",
    transform: "translate(79 -211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M73.38,160a7,7,0,0,1,1.86,5.3v11.52h-4V165a4,4,0,0,0-.81-2.79,3.35,3.35,0,0,0-2.57-.88H65.38a9.649,9.649,0,0,0-.58,2,12.07,12.07,0,0,0-.22,2.29v5.77a5.81,5.81,0,0,1-1.36,4.15A5,5,0,0,1,59.36,177a13.771,13.771,0,0,1-2.11-.17v-3.11c.37,0,.72.05,1,.05a2.38,2.38,0,0,0,1.83-.64,2.9,2.9,0,0,0,.59-2V166a10.27,10.27,0,0,1,.33-2.52,6.57,6.57,0,0,1,.91-2.15H58.78v-3.11h9.08A7.74,7.74,0,0,1,73.38,160Z",
    transform: "translate(79 -211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M79.71,170.46a8.36,8.36,0,0,1,.27-2.41,6.94,6.94,0,0,1,.71-1.56h3.19a15.24,15.24,0,0,0-.35,3.61v6.72H79.71Zm11-5.49a3.66,3.66,0,0,0-.91-2.75,3.94,3.94,0,0,0-2.82-.87H79.74v-3.11h7.48A7.83,7.83,0,0,1,92.73,160a6.65,6.65,0,0,1,1.91,5.12v11.69h-4Z",
    transform: "translate(79 -211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.025c0ee34feed06c24105e7c4a3e493e.svg";
export { ForwardRef as ReactComponent };